// extracted by mini-css-extract-plugin
module.exports = {"details":"Dv360AdAccount-module__details___-YLia","campaigns":"Dv360AdAccount-module__campaigns___2VBYT"};